export default function(element) {
  element.classList.add("element--highlighted")

  setTimeout(() => {
    element.classList.remove("element--highlighted")
  }, 1500)
}
